import React, { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import MainLayout from './components/layout/MainLayout'
import { routes } from './routes'
import Login from './pages/login/Login'
import LoginCallback from './pages/login/LoginCallbackPage'
import { OpenAPI} from "./admin-sdk/pms";
console.log('process.env.REACT_APP_ADMIN_GATEWAY_URL: ', process.env.REACT_APP_ADMIN_GATEWAY_URL)
OpenAPI.BASE = process.env.REACT_APP_ADMIN_GATEWAY_URL
function App() {
  const isAuthenticated = localStorage.getItem('accessToken') ? true : false

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
        <Route path="/" element={isAuthenticated ? <MainLayout /> : <Navigate to="/login" />}>
          {routes}
        </Route>
        <Route path="/login/callback" element={<LoginCallback />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
